import styled from "styled-components";
import {deviceDF} from 'assets/breakPoints'
export const Wrapper = styled.div`
  display: grid;
  margin-top: 90px;
  overflow: hidden;
  
`
export const Form = styled.form`
  display: grid;
  grid-template-columns: 600px 600px;
  grid-template-rows: 50px 50px; 
  column-gap: 50px;
  row-gap: 35px;
  margin: 0 auto;

  @media ${deviceDF.mobileL} {
    flex-direction: column;
    grid-template-columns:none;
    grid-template-rows: none;
    column-gap: none;
    row-gap: none;
    margin: none;
  }
`

export const CaptchaWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 2.3em;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 1.7rem 1.2rem;
`;
